import api from "api/axios";

export const intraoralFindingApi = (master) => {
  const base = `/admin/intraoral-findings/${master}`;

  return {
    list: (params) => api.get(base, { params }),
    create: (payload) => api.post(base, payload),
    update: (id, payload) => api.put(`${base}/${id}`, payload),
    remove: (id) => api.delete(`${base}/${id}`),
    importFile: (file) => {
      const body = new FormData();
      body.append("file", file);
      return api.post(`${base}/import`, body, {
        headers: { "Content-Type": "multipart/form-data" },
      });
    },
    download: (kind, params) =>
      api.get(`${base}/${kind}`, { params, responseType: "blob" }),
  };
};
